<!-- Shown while waiting for application load to complete before routing -->
@if (!initialCheckComplete) {
  <div class="loading-container">
    <i class="fa-solid fa-spinner fa-spin"></i>
  </div>
}
